<template>
    <div>
        Saída: {{ task.output.value }}
    </div>
</template>
<script>
    export default {
        props: {
            task: {
                type: Object
            }
        }
    }
</script>


// WEBPACK FOOTER //
// TestV1.vue?33d0dc14